import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import {
  AppBar,
  Grid,
  LinearProgress,
  Tab,
  Tabs,
} from '@material-ui/core';
import { 
                                                                                          // renderErrorText,
  renderSnackbarError,
} from '../form-global-components/components-form-components-for-react-final-form';
import {
                                                                                            // ButtonSave,
  ButtonSaveAndClose,
} from 'theme';
                                                                                            // import Save from '@material-ui/icons/Save';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import asyncValidate from './components/asyncValidate';
import { TabContainer } from '../custom-tab-container/custom-tab-container';
import EditViewReferralTabName from './components/tab-name';
import EditViewReferralTabDates from './components/tab-dates';
import EditViewReferralTabPrograms from './components/tab-programs';
import EditViewReferralTabClientDetails from './components/tab-client-details';
import EditViewReferralTabOutcome from './components/tab-outcome';
import EditViewReferralTabChangeLog from './components/tab-changelog';
class ReferralEdit extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      headerTabs: 0,
      subHeaderTabs1: 1,
      radio1Change: 0,
      select1Change: 0,
    };
  }
  componentDidUpdate() {
    /*** fix double render issue - start */
		if(this.props.match.params.id && !this.props.initialized)
			this.props.initialize(this.props.initialValues);
    /*** fix double render issue - end */
  }
  componentDidMount() {
    /*** fix double render issue - start */    
    this.props.initialize(this.props.initialValues);
    /*** fix double render issue - end */    
  }

  handleChangeHeader1 = (event, value) => {
    event.persist();
    this.setState({ headerTabs: value });
  }

  handleSubmitSaveAndClose = (values, reset, dispatch) => {
    var params = {
      /*** tab-name */
      'regid': values.regid,
      'fname': values.fname,
      'mname': values.mname,
      'lname': values.lname,
      'dob': values.dob,
      'gender': values.gender,
      'ethnicity': values.ethnicity,

      /*** tab-dates */
      'referralreceiveddate': values.referralreceiveddate,
      'referralapproveddate': values.referralapproveddate,
      'referralrequestedadmissiondate': values.referralrequestedadmissiondate,
      'referralapprovedadmissiondate': values.referralapprovedadmissiondate,
      'referralprojectedreleasedate': values.referralprojectedreleasedate,

      /*** tab-programs */
      'program': values.program,

      /*** Tab 1 - Assigned CJ Supervision - All Programs Details */
      'usprobationofficer': this.props.currentFormState.usprobationofficer,
      'uspretrialofficer': this.props.currentFormState.uspretrialofficer,
      'bexarcountyprobationofficer': this.props.currentFormState.bexarcountyprobationofficer,
      'specialtycourtcasemanager': this.props.currentFormState.specialtycourtcasemanager,
      'bexarcountypretrialofficer': this.props.currentFormState.bexarcountypretrialofficer,
      'cpscaseworker': this.props.currentFormState.cpscaseworker,
      'othersupervisingofficer': this.props.currentFormState.othersupervisingofficer,
      'supervisioncomments': this.props.currentFormState.supervisioncomments,

      /*** Tab 2 - Clinical Providers at Referral - All Programs Details */
      'clinicalprovidersnone': this.props.currentFormState.clinicalprovidersnone ,
      'clinicalprovidersctssa': this.props.currentFormState.clinicalprovidersctssa ,
      'clinicalprovidersctsmh': this.props.currentFormState.clinicalprovidersctsmh ,
      'clinicalproviderschcs': this.props.currentFormState.clinicalproviderschcs ,
      'clinicalprovidersalpha': this.props.currentFormState.clinicalprovidersalpha ,
      'clinicalproviderschcsmat': this.props.currentFormState.clinicalproviderschcsmat ,
      'clinicalprovidersnewseasonsmat': this.props.currentFormState.clinicalprovidersnewseasonsmat ,
      'clinicalprovidersmedmarkmat': this.props.currentFormState.clinicalprovidersmedmarkmat ,
      'clinicalprovidersstccteam': this.props.currentFormState.clinicalprovidersstccteam ,
      'clinicalprovidersrosettakeys': this.props.currentFormState.clinicalprovidersrosettakeys ,
      'clinicalproviderselitecounseling': this.props.currentFormState.clinicalproviderselitecounseling ,
      'clinicalprovidersotherprovider': this.props.currentFormState.clinicalprovidersotherprovider ,
      'clinicalproviderscomments': this.props.currentFormState.clinicalproviderscomments ,
        
      /*** tab-programs - BOP RRC - Officer */
      'bopsupervisingofficercomments': values.bopsupervisingofficercomments , 

      /*** tab-programs - BOP RRC - Program Requirements */
      'bopalchoholaftercareprogram': values.bopalchoholaftercareprogram , 
      'bopdrugaftercareprogram': values.bopdrugaftercareprogram , 
      'bopfinancialresponsibilityprogram': values.bopfinancialresponsibilityprogram , 
      'bopmentalhealthaftercareprogram': values.bopmentalhealthaftercareprogram , 
      'boppsf': values.boppsf , 

      /*** tab-programs - BOP RRC - BOP Institution */
      'boplevelofsecurity': values.boplevelofsecurity,
      'bopinstitution': values.bopinstitution,
      'bopinstitutioncomments': values.bopinstitutioncomments,

      /*** tab-programs - BOP RRC - Gang Affiliation */
      'bopgangaffiliation': values.bopgangaffiliation,
      'bopgangaffiliationcomments': values.bopgangaffiliationcomments,

      /*** tab-programs - OPC US PTS-Psy - Officer */
      'opcusptspsyofficercomments': values.opcusptspsyofficercomments,







      /*** tab-client-details */
      /*** tab-client-details - tab-conditions */
      'referralhomelesshistory': values.referralhomelesshistory,
      'referralhomelesscurrent': values.referralhomelesscurrent,
      'referralhomelessna': values.referralhomelessna,
      'referralmentalhealthissueshistory': values.referralmentalhealthissueshistory,
      'referralmentalhealthissuescurrent': values.referralmentalhealthissuescurrent,
      'referralmentalhealthissuesna': values.referralmentalhealthissuesna,
      'referralsubstanceusedisorderissueshistory': values.referralsubstanceusedisorderissueshistory,
      'referralsubstanceusedisorderissuescurrent': values.referralsubstanceusedisorderissuescurrent,
      'referralsubstanceusedisorderissuesna': values.referralsubstanceusedisorderissuesna,
      'referralcooccurringhistory': values.referralcooccurringhistory,
      'referralcooccurringcurrent': values.referralcooccurringcurrent,
      'referralcooccurringna': values.referralcooccurringna,
      'referralemployedduringpasthistory': values.referralemployedduringpasthistory,
      'referralemployedduringpastcurrent': values.referralemployedduringpastcurrent,
      'referralemployedduringpastna': values.referralemployedduringpastna,

      'referralriskasperpetrator': values.referralriskasperpetrator,
      'referralriskofvictimization': values.referralriskofvictimization,

      'referralprescribedmedications': this.props.currentFormState.referralprescribedmedications,
      'referralmedicationsupplyprovided': this.props.currentFormState.referralmedicationsupplyprovided,

      /*** tab-client-details - tab-education */
      'educationcompleted': values.educationcompleted,

      /*** tab-client-details - tab-referral */
      'referralsource': values.referralsource,
      'priorcriminalbackground': values.priorcriminalbackground,
      'currentinstantoffense': values.currentinstantoffense,

      /*** tab-client-details - tab-support */
      'supportsystem': values.supportsystem,
      'supportsystemcomments': values.supportsystemcomments,
      'numberofchildren': values.numberofchildren,


      /*** tab-outcome */
      'referraloutcome': values.referraloutcome,
      'referraloutcomecomments': values.referraloutcomecomments,

      // const c_USER = this.context
      // 'referralcreatedbyloginid': this.props.currentUser.id,
      // 'referrallasttouchedbyloginid': this.props.currentUser.id,

      // 'referralcreatedbyloginid': this.context.id,
      // 'referrallasttouchedbyloginid': this.context.id,

      'referralcreatedbyloginid': this.props.loginID,
      'referrallasttouchedbyloginid': this.props.loginID,

    };

                                                                                            // console.log ('4444-504-890 - EditViewReferral-AAA - render - this.props = ', this.props);
                                                                                            // console.log ('4444-504-890 - EditViewReferral-AAA - render - this.props.match.params.id = ', this.props.match.params.id);
                                                                                            // console.log ('4444-504-891 - EditViewReferral-AAA - render - this.context.id = ', this.context.id);
                                                                                            // console.log ('4444-504-892 - EditViewReferral-AAA - render - params = ', params);

    if (this.props.referralMode === 0) {
        this.props.addReferral(params);
    }else {
        switch (values.referraloutcome) {
          case 1:
          case '1':
          case 2:
          case '2':
            this.props.editReferralSaveAndClose(this.props.match.params.id, params);
            break;
          case 3:
          case '3':
            this.props.transferReferralToCients(this.props.match.params.id, params);
            break;
          case 4:
          case '4':
          case 5:
          case '5':
          case 6:
          case '6':
            this.props.archiveReferral(this.props.match.params.id, params);
            break;
          default:
            this.props.editReferralSaveAndClose(this.props.match.params.id, params);
            break;
        }
    }

  }

  render() {
                                                                                  // console.log ('4444-3423 - ReferralEdit-1-bbb - Props = ', this.props);
    return (
      <form onSubmit={this.props.handleSubmit(this.handleSubmitSaveAndClose)}>
        <div >
          <AppBar position="static" color="default">



          <Grid container spacing={3} >
            <Grid item xs={12} sm={6}>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ButtonSaveAndClose
                type='submit'
                
                size='large'
                fullWidth
                disabled={!this.props.valid || this.props.referralMode === 3}
                >
                <SaveAltIcon />
                &nbsp;
                Save & Close
              </ButtonSaveAndClose>
            </Grid>
          </Grid> 

          {this.props.loadingList && <LinearProgress variant="buffer"  value={5} valueBuffer={10} color="secondary" /> }

            <Tabs
              value={this.state.headerTabs}
              onChange={this.handleChangeHeader1}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
                                                                                              // scrollButtons="auto"
              scrollButtons="on"
            >
              <Tab label="Name" />
              <Tab label="Programs" />
              <Tab label="All Program Details" />
              <Tab label="Dates" />
              <Tab label="Referral Outcome" />
              <Tab label="Change Log" />
            </Tabs>

          </AppBar> 


          <Field
              component={renderSnackbarError}
              id='notifyFormErrors'
              name='notifyFormErrors'
            />


          {this.state.headerTabs === 0 && <TabContainer>
            <EditViewReferralTabName
              locked={this.props.referralMode === 3 ? true : false}
            />
          </TabContainer>}

          {this.state.headerTabs === 1 && <TabContainer>
            <EditViewReferralTabPrograms
              locked={this.props.referralMode === 3 ? true : false}
              
              programSelected={this.props.currentFormState === undefined ? this.props.initialValues.program : this.props.currentFormState.program}

              programsList={this.props.programsList}
              // bopinstitutionsList={this.props.bopinstitutionsList.bopinstitutions}
              // gangaffiliationsList={this.props.gangaffiliationsList.gangaffiliations}
              bopinstitutionsList={this.props.bopinstitutionsList}
              gangaffiliationsList={this.props.gangaffiliationsList}

              allowChangeProgram={false}
            /> 
          </TabContainer>}

          {this.state.headerTabs === 2 && <TabContainer>
            <EditViewReferralTabClientDetails
              locked={this.props.referralMode === 3 ? true : false}
              referralMode={this.props.referralMode}
              // referralsourcesList={this.props.referralsourcesList.referralsources}
              referralsourcesList={this.props.referralsourcesList}
            />
          </TabContainer>}

          {this.state.headerTabs === 3 && <TabContainer>
            <EditViewReferralTabDates
              locked={this.props.referralMode === 3 ? true : false}
              showReferralOutcome={this.props.referralMode}
              referraloutcome={this.props.initialValues.referraloutcome}
            />
          </TabContainer>}

          {this.state.headerTabs === 4 && <TabContainer>
            <EditViewReferralTabOutcome
              locked={this.props.referralMode === 3 ? true : false}
              showReferralOutcome={this.props.referralMode}
            />
          </TabContainer>}

          {this.state.headerTabs === 5 && <TabContainer>
            <EditViewReferralTabChangeLog
            />
          </TabContainer>}

          {this.props.loadingList && <LinearProgress variant="buffer"  value={5} valueBuffer={10} color="secondary" /> }

          <Grid container spacing={3} >
            <Grid item xs={12} sm={6}>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ButtonSaveAndClose
                type='submit'
                
                size='large'
                fullWidth
                disabled={!this.props.valid || this.props.referralMode === 3}
                >
                <SaveAltIcon />
                &nbsp;
                Save & Close
              </ButtonSaveAndClose>
            </Grid>
          </Grid>


        </div>
      </form>
    );
  }
}
ReferralEdit.propTypes = {
  /*** Referral Type - 0 - add - 1 - edit - 2 - view */
  referralMode: PropTypes.number,
  addReferral: PropTypes.func,
  editReferralSave: PropTypes.func,
  editReferralSaveAndClose: PropTypes.func,
  transferReferralToCients: PropTypes.func,
  archiveReferral: PropTypes.func,
};
ReferralEdit = reduxForm({
  form: 'ReferralEditForm', // a unique name for this form
  /*** validate form values */
  asyncValidate,
  /*** double render issue */
  enableReinitialize: true,
  // /*** preserve form data */
  // destroyOnUnmount: false,
  // /*** unregister fields on unmount */
  // forceUnregisterOnUnmount: true,
})(ReferralEdit);
export default withRouter(ReferralEdit);
